import urlTool from '@/tools/url';
import createStorage from '@/storage';
const Store = createStorage({ name: 'compare' });
import Shop from '@/shop';

/**
 * @desc
 * Парсилка ответа ручки, приводит к виду, готовый для мержа с фильтром из URL
 *
 * @param {Object} seoFilter - ответ ручки
 *
 * @return {Object} - сформованный ответ, сгруппированный по параметрам и свойствам
 */
function parseSeoFilter(seoFilter) {
  let parsed = {
    characteristics: [],
    options: {},
    properties: {},
    price: {},
  };

  seoFilter.characteristics.forEach(characteristic => {
    // факап - characteristic.id - это именно то, что нужно для фильтров )))
    // так же приводим к строке, чтобы это было единообразно во всех местах
    parsed.characteristics.push(characteristic.id.toString());
  });

  seoFilter.option_values.forEach(option => {
    /*
     * забавно то, что option_name_id - это как раз Id свойства.
     * option.id - id значения.
     */
    let id = option.option_name_id;

    if (!parsed.options[id]) {
      parsed.options[id] = [];
    }
    parsed.options[id].push(option.id.toString());
  });

  return parsed;
}

export default function() {
  const lang = urlTool.getKeyValue('lang') || '';
  let versionOnPage = Shop.pageData
    .get('collection_filter_version')
    .collection_filter_version;

  let filterKey = urlTool.collectionFilter ? `${urlTool.collection}___${urlTool.collectionFilter}` : '';
  const request_url = `${window.location.origin}/front_api/collections/${urlTool.collection}/collection_filters/${urlTool.collectionFilter}.json`;

  let path = new URL(request_url);

  if (lang) {
    path.searchParams.set('lang', lang);
  }

  return new Promise((resolve, reject) => {
    Store.getItem(filterKey)
      .then((filter) => {
        let needLoad = !filter && filterKey;
        let needReload = filter && filter.version != versionOnPage;

        if (needLoad || needReload) {
          return fetch(path)
            .then((response) => {
              return response.json();
            });
        }

        return {};
      })
      .then((filterToSave) => {
        let parsed = {};

        function isEmpty(obj) {
          return Object.keys(obj).length === 0 && obj.constructor === Object;
        }

        if (isEmpty(filterToSave)) {
          return {};
        }

        parsed = parseSeoFilter(filterToSave);
        parsed.version = versionOnPage;

        return Store.setItem(filterKey, parsed);
      })
      .then(() => {
        return Store.getItem(filterKey);
      })
      .then((filter) => {
        resolve(filter);
      })
      .catch((result) => {
        reject(result);
      });
  });
};
